module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row search-box"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-1"
  }, [_c('vueInstant', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    attrs: {
      "type": "google",
      "suggestion-attribute": _vm.suggestionAttribute,
      "suggestions": _vm.suggestions
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "click-button": _vm.clickInput,
      "input": [function($event) {
        _vm.val = $event
      }, _vm.changed]
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row example-row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h4', [_vm._v("Installation")]), _vm._v(" "), _c('vue-markdown', {
    attrs: {
      "typographer": true
    }
  }, [_vm._v("\n```\nnpm install --save vue-instant\n```\n        ")]), _vm._v(" "), _c('vue-markdown', {
    attrs: {
      "typographer": true
    }
  }, [_vm._v("\nDistribution import\n```javascript\nimport 'vue-instant/dist/vue-instant.css'\nimport VueInstant from 'vue-instant/dist/vue-instant.common'\nVue.use(VueInstant)\n```\n        ")]), _vm._v("\n\n        Browser support\n            "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row example-row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', [_c('vueInstant', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    staticClass: "row amazon-bg",
    attrs: {
      "type": "amazon",
      "suggestion-attribute": _vm.suggestionAttribute,
      "placeholder": "type your favorite film...",
      "suggestions": _vm.suggestions
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "selected": _vm.setInstantData,
      "input": [function($event) {
        _vm.val = $event
      }, _vm.changed]
    }
  })], 1), _vm._v(" "), _c('pre', {
    staticClass: "json-format"
  }, [_vm._v(_vm._s(_vm.instantData))])])]), _vm._v(" "), _c('div', {
    staticClass: "row example-row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h4', [_vm._v("Styles")]), _vm._v(" "), _c('div', {
    staticClass: "styles-box"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.changeType('google')
      }
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.changeType('facebook')
      }
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.changeType('amazon')
      }
    }
  }, [_vm._v("Amazon")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.changeType('spotify')
      }
    }
  }, [_vm._v("Spotify")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.changeType('twitter')
      }
    }
  }, [_vm._v("Twitter")]), _vm._v(" "), _c('div'), _vm._v(" "), _vm._m(4)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    style: (_vm.getStyle)
  }, [_c('vueInstant', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    attrs: {
      "type": _vm.exampleType,
      "suggestion-attribute": _vm.suggestionAttribute,
      "placeholder": "type your favorite film...",
      "suggestions": _vm.suggestions
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "selected": _vm.setInstantData,
      "input": [function($event) {
        _vm.val = $event
      }, _vm.changed]
    }
  })], 1)])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row example-row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h4', [_vm._v("Custom Box")]), _vm._v(" "), _c('p', [_vm._v("You can override the styles and customize the searchbox. It's easy.\n        ")]), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', [_vm._v("3. Copy the css generated in your css file.")]), _vm._v(" "), _c('p', [_vm._v("4. Create a new css class called .sbx-custom__input-placeholder with the same properties of the class called \".sbx-custom__input\".")]), _vm._v(" "), _c('p', [_vm._v("5. Add this class in your css with your autocomplete background and your autocomplete color.")]), _vm._v(" "), _c('vue-markdown', {
    attrs: {
      "typographer": true
    }
  }, [_vm._v("\n```css\n.vue-instant__suggestions li.highlighted__custom {\n  background-color: \"your decision\";\n  color: \"your decision\";\n}\n.vue-instant__suggestions {\n  margin-top: \"your decision\";\n}\n```\n          ")])], 1)]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('link', {
    attrs: {
      "href": "https://fonts.googleapis.com/css?family=Source+Sans+Pro",
      "rel": "stylesheet"
    }
  }), _vm._v(" "), _vm._m(11)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "jumbotron jumbotron-fluid"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "display-5",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("VUE INSTANT")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("vue instant allows you to easily create custom search controls with auto suggestions for your vue 2 application.")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vue-instant"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/npm/dt/vue-instant.svg",
      "alt": "downloads"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vue-instant"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/npm/v/vue-instant.svg",
      "alt": "Version"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vue-instant"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/npm/l/vue-instant.svg",
      "alt": "License"
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "script-colors"
  }, [_c('div', [_c('code', [_vm._v("\n                    <script src=\"vue.js\">")])]), _vm._v(" "), _c('div', [_c('code', [_vm._v("\n                    <script src=\"vue-instant/dist/vue-instant.browser.js\">")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Example\n              "), _c('small', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://jsfiddle.net/santiblanko/dqo6vr57/"
    }
  }, [_vm._v("Fiddle")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "example-title-text"
  }, [_c('pre', {
    staticClass: "black-color"
  }, [_vm._v("try typing a film")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://shipow.github.io/searchbox/"
    }
  }, [_vm._v(" You can create your own style in this external page!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row example-row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h4', [_vm._v("Attributes")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticClass: "bg-inverse"
  }, [_c('td', [_vm._v("Attribute")]), _vm._v(" "), _c('td', [_vm._v("Description")]), _vm._v(" "), _c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("Required")]), _vm._v(" "), _c('td', [_vm._v("Default")]), _vm._v(" "), _c('td', [_vm._v("Accepted values")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("v-model")]), _vm._v(" "), _c('td', [_vm._v("binding the component value.")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("suggestions")]), _vm._v(" "), _c('td', [_vm._v("collection of suggestions that appear while the user is typing")]), _vm._v(" "), _c('td', [_vm._v("Array")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("suggestion-attribute")]), _vm._v(" "), _c('td', [_vm._v("The attribute name of the object to render in the searchbox")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("The style of the input")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("facebook")]), _vm._v(" "), _c('td', [_vm._v("['google', 'facebook', 'twitter', 'amazon', 'spotify', 'custom']")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-autocomplete")]), _vm._v(" "), _c('td', [_vm._v("only show suggests, or suggests with autocomplete.")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("full")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("placeholder")]), _vm._v(" "), _c('td', [_vm._v("same as placeholder in native input")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("write something...")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', [_vm._v("same as name in native input  ")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("vueInstant")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("autofocus")]), _vm._v(" "), _c('td', [_vm._v("same as autofocus in native input")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', [_vm._v("same as disabled in native input")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("-")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row example-row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h4', [_vm._v("Events")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "bg-inverse"
  }, [_c('td', [_vm._v("Event")]), _vm._v(" "), _c('td', [_vm._v("Description")]), _vm._v(" "), _c('td', [_vm._v("Event Data")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("@input")]), _vm._v(" "), _c('td', [_vm._v("triggers when the value changes")]), _vm._v(" "), _c('td', [_vm._v("(value: string)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("@click-input")]), _vm._v(" "), _c('td', [_vm._v("triggers when the text input is clicked")]), _vm._v(" "), _c('td', [_vm._v("(event: Event)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("@click-button")]), _vm._v(" "), _c('td', [_vm._v("triggers when the submit button is clicked")]), _vm._v(" "), _c('td', [_vm._v("(value: string)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("@selected")]), _vm._v(" "), _c('td', [_vm._v("triggers when the selectedObject changes")]), _vm._v(" "), _c('td', [_vm._v("(selected: obj)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("@enter")]), _vm._v(" "), _c('td', [_vm._v("triggers when the enter key is pressed")]), _vm._v(" "), _c('td', [_vm._v("(selected: obj)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("@key-up")]), _vm._v(" "), _c('td', [_vm._v("triggers when the arrowup key is pressed")]), _vm._v(" "), _c('td', [_vm._v("(selected: obj)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("@key-down")]), _vm._v(" "), _c('td', [_vm._v("triggers when the arrowdown key is pressed")]), _vm._v(" "), _c('td', [_vm._v("(selected: obj)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("@key-right")]), _vm._v(" "), _c('td', [_vm._v("triggers when the arrowright key is pressed")]), _vm._v(" "), _c('td', [_vm._v("(selected: obj)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("@clear")]), _vm._v(" "), _c('td', [_vm._v("triggers when the clear button is pressed")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("@escape")]), _vm._v(" "), _c('td', [_vm._v("triggers when the escape key is pressed")]), _vm._v(" "), _c('td', [_vm._v("(event: Event)")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("1. You need define the "), _c('code', {
    staticClass: "highlighted"
  }, [_vm._v("type")]), _vm._v(" prop with the 'custom' value")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("2. The next step is go to "), _c('a', {
    attrs: {
      "href": "http://shipow.github.io/searchbox/"
    }
  }, [_vm._v("\n        http://shipow.github.io/searchbox/")]), _vm._v(" and generate your own style or create your own inspired in shipow code.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row example-row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/santiblanko/vue-instant",
      "data-count-href": "/santiblanko/vue-instant/stargazers",
      "data-count-api": "/repos/santiblanko/vue-instant#stargazers_count",
      "data-count-aria-label": "# stargazers on GitHub",
      "aria-label": "Star santiblanko/vue-instant on GitHub"
    }
  }, [_vm._v("Star")]), _vm._v(" "), _c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/santiblanko/vue-instant/fork",
      "data-count-href": "/santiblanko/vue-instant/network",
      "data-count-api": "/repos/santiblanko/vue-instant#forks_count",
      "data-count-aria-label": "# forks on GitHub",
      "aria-label": "Fork santiblanko/vue-instant on GitHub"
    }
  }, [_vm._v("Fork")]), _vm._v(" "), _c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/santiblanko",
      "data-count-href": "/santiblanko/followers",
      "data-count-api": "/users/santiblanko#followers",
      "data-count-aria-label": "# followers on GitHub",
      "aria-label": "Follow @santiblanko on GitHub"
    }
  }, [_vm._v("Follow @santiblanko")]), _vm._v(" "), _c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/santiblanko/vue-instant/archive/master.zip",
      "aria-label": "Download santiblanko/vue-instant on GitHub"
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/santiblanko/vue-instant/issues",
      "data-count-api": "/repos/santiblanko/vue-instant#open_issues_count",
      "data-count-aria-label": "# issues on GitHub",
      "aria-label": "Issue santiblanko/vue-instant on GitHub"
    }
  }, [_vm._v("Issue")]), _vm._v(" "), _c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/santiblanko/vue-instant/subscription",
      "data-count-href": "/santiblanko/vue-instant/watchers",
      "data-count-api": "/repos/santiblanko/vue-instant#subscribers_count",
      "data-count-aria-label": "# watchers on GitHub",
      "aria-label": "Watch santiblanko/vue-instant on GitHub"
    }
  }, [_vm._v("Watch")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/santiblanko/vue-instant"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "border": "0",
      "z-index": "999"
    },
    attrs: {
      "src": "https://camo.githubusercontent.com/652c5b9acfaddf3a9c326fa6bde407b87f7be0f4/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6f72616e67655f6666373630302e706e67",
      "alt": "Fork me on GitHub",
      "data-canonical-src": "https://s3.amazonaws.com/github/ribbons/forkme_right_orange_ff7600.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('small', [_vm._v("Released under the "), _c('a', {
    attrs: {
      "href": "https://opensource.org/licenses/MIT",
      "target": "_blank"
    }
  }, [_vm._v("MIT License")]), _c('br'), _vm._v("Copyright © 2017 Santiago Blanco "), _c('a', {
    attrs: {
      "href": "http://twitter.com/santiblanko"
    }
  }, [_vm._v("(@santiblanko)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66d3edb3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orch/builder.vue
// module id = 263
// module chunks = 2